<template>
  <div id="app">
    <router-view
      @auth="auth"
      @logout="logout"
    ></router-view>
    <md-snackbar
      md-position="bottom center"
      ref="messageBar"
    >
      {{ message }}
    </md-snackbar>
  </div>
</template>

<script>
import 'vue-material/dist/vue-material.css'
import { mapActions } from 'vuex'
import Auth0Lock from 'auth0-lock'
import Promise from 'bluebird'

export default {
  components: {
  },
  name: 'app',
  data () {
    return {
      message: null,
      authLock: null
    }
  },
  created () {
    var authData
    if (localStorage && (authData = localStorage.getItem('auth'))) {
      authData = JSON.parse(authData)
      this.onAuthenticated(authData)
    }
  },
  methods: {
    ...mapActions(['authenticated', 'unauthenticated']),
    getAuthLock () {
      if (!this.authLock) {
        this.authLock = new Auth0Lock(
          '3jPwkv2_50tKdzYS1xVXjS1lWlg8yo2h',
          'art-jump.auth0.com',
          {
            language: 'ru',
            theme: {
              labeledSubmitButton: false
            },
            languageDictionary: {
              title: 'Авторизация'
            },
            auth: {
              redirect: false,
              params: {
                scope: 'openid app_metadata email'
              }
            }
          }
        )
      }
      return this.authLock
    },
    auth (callback) {
      this.getAuthLock().on('authenticated', (result) => {
        this.onAuthenticated(result).then(() => {
          if (localStorage) {
            localStorage.setItem('auth', JSON.stringify(result))
          }
          if (callback) {
            this.$nextTick(() => {
              callback()
            })
          }
        }).catch((err) => {
          this.handleError(err)
        })
      })
      this.getAuthLock().show()
    },
    onAuthenticated (authData) {
      return new Promise((resolve, reject) => {
        this.getAuthLock().getUserInfo(authData.accessToken, (error, profile) => {
          if (error) {
            reject(error)
            return
          }
          this.authenticated({ authData, profile })
          resolve()
        })
      })
    },
    logout () {
      this.unauthenticated()
      if (localStorage) {
        localStorage.removeItem('auth')
      }
    },
    showMessage (message) {
      this.message = message
      this.$nextTick(() => {
        this.$refs.messageBar.open()
      })
    }
  }
}
</script>

<style lang="sass">
#app
  height: 100%
</style>



// WEBPACK FOOTER //
// App.vue?3e99b2b6